import {
  useGetActivityPurchase,
  useCreateActivityPurchase,
} from 'api-hooks/order/activity';
import { ActivitySaleModel } from 'api-hooks/sale/activity';
import { KIND, Notification } from 'baseui/notification';
import { NavigationRoutes } from 'common/constants';
import LoadingComponent from 'components/common/loading';
import ErrorViewComponent from 'components/elements/error-view-component';
import FetchWrapperComponent from 'components/elements/fetch-wrapper-component';
import { DetailContainer } from 'components/styles';
import useApprovalableEdit from 'hooks/use-approvalable-edit';
import { useRouter } from 'next/router';
import { NavigationProps } from 'types';

import ActivityPurchaseForm from './component/form';
import { ActivityPurchaseFormType } from './component/form-type';

export type ActivityPurchaseViewParams = {
  id: string;
  defaultValues?: ActivityPurchaseFormType;
  activitySale?: ActivitySaleModel;
};

export default function ActivityPurchaseView(
  props: NavigationProps<NavigationRoutes.ActivityPurchasesView>,
) {
  const { query } = useRouter();
  const id = query?.id as string;
  const { data, error, isLoading, isFetching, refetch } =
    useGetActivityPurchase({ id });

  const { mutateAsync, error: errorMutate } = useCreateActivityPurchase();

  const activityPurchase = data?.data;

  const onResolve = useApprovalableEdit('activity-purchases');

  return (
    <FetchWrapperComponent
      onRetry={refetch}
      loadingComponent={<LoadingComponent />}
      error={error}
      errorComponent={
        <DetailContainer>
          <ErrorViewComponent refetch={refetch} />
        </DetailContainer>
      }
      isLoading={isLoading || isFetching}
      component={
        <>
          <ActivityPurchaseForm
            {...props}
            renderError={
              !!errorMutate &&
              !!errorMutate.message && (
                <>
                  <Notification
                    overrides={{
                      Body: {
                        style: { width: 'auto', wordBreak: 'break-all' },
                      },
                    }}
                    kind={KIND.negative}
                    closeable
                  >
                    {() => errorMutate.message}
                  </Notification>
                </>
              )
            }
            activityPurchases={activityPurchase}
            onSubmit={async (input, form) => {
              const result = await mutateAsync(input);
              onResolve(result);
              return result.data;
            }}
          />
        </>
      }
    />
  );
}
